import React from 'react';
import { injectIntl } from 'gatsby-plugin-intl';
import { SEO } from './common';

const Redirect = ({ intl }) => <SEO title={`${intl.formatMessage({ id: 'title' })}`} />;

export default injectIntl(Redirect);
